<template>
  <jee-aside-layout class="collect-task-container" hiddenHeader>
    <template slot="asideMain">
      <base-tree
        v-bind="tree"
        :data="collectTaskTree"
        @handleClick="handleClick"
      ></base-tree>
    </template>
    <template slot="main">
      <slot></slot>
    </template>
  </jee-aside-layout>
</template>

<script>
import taskTreeMixin from './taskTreeMixin'

export default {
  name: 'interactCollectTaskTree',
  mixins: [taskTreeMixin]
}
</script>
